import { ApiError } from './api-error';

export class FormExpiredError extends ApiError {}
